import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';
import Select from "react-select"; 



function safeArray(data) {
  return Array.isArray(data) ? data : (data && data.rows ? data.rows : []);
}

const DOCUMENT_TYPES = [
  { value: 'offer', label: 'Angebot' },
  { value: 'order', label: 'Auftrag' },
  { value: 'invoice', label: 'Rechnung' },
  { value: 'creditnote', label: 'Gutschrift' },
  { value: 'other', label: 'Sonstiges' }
];

const getFormLink = (documentType, documentId) => {
  if (!documentType || !documentId) return null;
  switch (documentType) {
    case "offer": return `/offers/${documentId}/edit`;
    case "order": return `/orders/${documentId}/edit`;
    case "invoice": return `/invoices/${documentId}/edit`;
    case "creditnote": return `/creditnotes/${documentId}/edit`;
    default: return null;
  }
};

const DocumentNumberCell = ({ type, id, allDocumentNumbers, label }) => {
  const key = `${type}:${id}`;
  return (
    <span>
      {allDocumentNumbers[key]
        ? allDocumentNumbers[key]
        : (label || id)}
    </span>
  );
};

const PipelineDocumentLinkForm = ({ pipelineInstId }) => {
  const [links, setLinks] = useState([]);
  const [instances, setInstances] = useState([]);
  const [pipelineInstance, setPipelineInstance] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [newLink, setNewLink] = useState({
    pipelineInstId: pipelineInstId || '',
    documentType: '',
    documentId: '',
    comment: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingLink, setEditingLink] = useState(null);
  const [filterType, setFilterType] = useState(null);
const [filterInstance, setFilterInstance] = useState(null);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const limit = 20; // oder was du willst

const instanceOptions = instances.map(i => ({
  value: i.id,
  label: i.name || `#${i.id}`
}));


  const [allDocumentNumbers, setAllDocumentNumbers] = useState({});
  useEffect(() => {
    const missing = links
      .filter(l => l.documentType !== "other" && l.documentId)
      .filter(l => !allDocumentNumbers[`${l.documentType}:${l.documentId}`]);
    if (missing.length === 0) return;
    missing.forEach(async l => {
      try {
        const res = await api.get(`/documents/${l.documentType}/${l.documentId}`);
        setAllDocumentNumbers(prev => ({
          ...prev,
          [`${l.documentType}:${l.documentId}`]: res.data.documentNumber || res.data.number || l.documentId
        }));
      } catch {
        setAllDocumentNumbers(prev => ({
          ...prev,
          [`${l.documentType}:${l.documentId}`]: l.documentId
        }));
      }
    });
    // eslint-disable-next-line
  }, [links]);

  useEffect(() => {
  const fetchAll = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        limit,
        page: currentPage,
      };
      if (pipelineInstId) params.pipelineInstId = pipelineInstId;
      if (filterInstance?.value) params.pipelineInstId = filterInstance.value;
      if (filterType?.value) params.documentType = filterType.value;

      const [lnks, inst] = await Promise.all([
        api.get('/pipeline-document-links', { params }),
        pipelineInstId
          ? api.get(`/pipeline-instances/${pipelineInstId}`)
          : api.get('/pipeline-instances'),
      ]);
      setLinks(lnks.data.data || lnks.data); // backend liefert ggf. { data, page, pages, ... }
      setTotalPages(lnks.data.pages || 1);
      if (pipelineInstId) setPipelineInstance(inst.data);
      else setInstances(safeArray(inst.data));
    } catch (err) {
      setError('Fehler beim Laden der Dokument-Links.');
    }
    setLoading(false);
  };
  fetchAll();
}, [pipelineInstId, filterType, filterInstance, currentPage]);

  // --- Für neuen Link: Dokumente laden wie gehabt ---
  useEffect(() => {
    const fetchDocuments = async () => {
      setDocuments([]);
      setNewLink(nl => ({ ...nl, documentId: '' }));
      if (!newLink.documentType || newLink.documentType === 'other') return;
      let customerId = null;
      if (pipelineInstance) customerId = pipelineInstance.customerId;
      else if (newLink.pipelineInstId) {
        const found = instances.find(i => i.id === newLink.pipelineInstId);
        customerId = found?.customerId;
      }
      if (!customerId) return;
      try {
        const res = await api.get('/documents', {
          params: { customerId, documentType: newLink.documentType }
        });
        setDocuments(safeArray(res.data));
      } catch (e) {
        setDocuments([]);
      }
    };
    fetchDocuments();
    // eslint-disable-next-line
  }, [newLink.documentType, newLink.pipelineInstId, pipelineInstance, instances]);

  // --- Edit: Dokumente nachladen, wenn im Edit-Modus ---
  useEffect(() => {
    const fetchEditDocuments = async () => {
      if (!editingLink || !editingLink.documentType || editingLink.documentType === 'other') {
        setDocuments([]); // Leeren, falls kein Edit oder Typ "other"
        return;
      }
      let customerId = null;
      if (pipelineInstance) customerId = pipelineInstance.customerId;
      else if (editingLink.pipelineInstId) {
        const found = instances.find(i => i.id === editingLink.pipelineInstId);
        customerId = found?.customerId;
      }
      if (!customerId) return;
      try {
        const res = await api.get('/documents', {
          params: { customerId, documentType: editingLink.documentType }
        });
        setDocuments(safeArray(res.data));
      } catch (e) {
        setDocuments([]);
      }
    };
    fetchEditDocuments();
    // eslint-disable-next-line
  }, [editingLink, pipelineInstance, instances]);

  // Hinzufügen
  const handleAddLink = async () => {
    const pipId = pipelineInstId || newLink.pipelineInstId;
    const { documentType, documentId, comment } = newLink;
    if (!pipId || !documentType || (!documentId && documentType !== 'other')) {
      alert('Bitte Vorgang, Dokumenttyp und Dokument wählen.');
      return;
    }
    try {
      const response = await api.post('/pipeline-document-links', {
        pipelineInstId: pipId,
        documentType,
        documentId,
        comment
      });
      setLinks([response.data, ...links]);
      setNewLink({ pipelineInstId: pipId, documentType: '', documentId: '', comment: '' });
      setDocuments([]);
    } catch {
      alert('Fehler beim Hinzufügen des Links.');
    }
  };

  // Löschen
  const handleDeleteLink = async (id) => {
    if (!window.confirm('Wirklich löschen?')) return;
    try {
      await api.delete(`/pipeline-document-links/${id}`);
      setLinks(links.filter(l => l.id !== id));
    } catch {
      alert('Fehler beim Löschen des Links.');
    }
  };

  // Bearbeiten starten
  const handleEditClick = (l) => {
    setEditingLink({ ...l });
    setDocuments([]); // Leert die Dokumente, damit das neue useEffect lädt!
  };

  // Bearbeitung abbrechen
  const handleCancelEdit = () => setEditingLink(null);

  // Edit-Felder aktualisieren
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditingLink(prev => ({ ...prev, [name]: value }));
  };

  // Speichern der Änderungen
  const handleSaveLink = async () => {
    const { id, documentType, documentId, comment } = editingLink;
    const pipId = pipelineInstId || editingLink.pipelineInstId;
    if (!pipId || !documentType || (!documentId && documentType !== 'other')) {
      alert('Bitte Vorgang, Dokumenttyp und Dokument angeben.');
      return;
    }
    try {
      const response = await api.put(`/pipeline-document-links/${id}`, {
        pipelineInstId: pipId,
        documentType,
        documentId,
        comment
      });
      setLinks(links.map(l => l.id === id ? response.data : l));
      setEditingLink(null);
    } catch {
      alert('Fehler beim Aktualisieren des Links.');
    }
  };

  if (loading) return <div>Lade Dokument-Links...</div>;
  if (error) return <div>{error}</div>;

  // Styles
  const buttonStyle = { fontSize: '15px', padding: '5px 10px', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', marginRight: '5px' };
  const addButtonStyle = { ...buttonStyle, background: '#28a745' };
  const editButtonStyle = { ...buttonStyle, background: '#007bff' };
  const saveButtonStyle = { ...buttonStyle, background: '#28a745' };
  const cancelButtonStyle = { ...buttonStyle, background: '#6c757d' };
  const deleteButtonStyle = { ...buttonStyle, background: '#dc3545' };

  let instanceLabel = "-";
  if (pipelineInstId) {
    if (pipelineInstance) instanceLabel = pipelineInstance.name;
  } else if (newLink.pipelineInstId && instances.length) {
    const found = instances.find(i => i.id === newLink.pipelineInstId);
    if (found) instanceLabel = found.name;
  }
const isModal = !!pipelineInstId;

  return (
    <div>
      <Helmet>
        <title>Dokument-Links</title>
        <meta name="description" content="CRM Dokument-Links verwalten" />
      </Helmet>
      <h2>Vorgangs Dokumente</h2>

      {/* Formular für neuen Link */}
            {/* Hinzufügen-Zeile nur im Modal */}
      {isModal && (
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '10px', marginLeft: '40px', width: '90%' }}>
          {/* Das ursprüngliche Hinzufügen-Formular, außer die Selectbox für Vorgang */}
          <select
            value={newLink.documentType}
            onChange={e => setNewLink({ ...newLink, documentType: e.target.value, documentId: '', comment: '' })}
          >
            <option value="">Typ wählen</option>
            {DOCUMENT_TYPES.map(dt => <option key={dt.value} value={dt.value}>{dt.label}</option>)}
          </select>
          {newLink.documentType && newLink.documentType !== 'other' ? (
            <select
              value={newLink.documentId}
              onChange={e => {
                const doc = documents.find(d => String(d.id) === e.target.value);
                setNewLink({
                  ...newLink,
                  documentId: e.target.value,
                });
              }}
            >
              <option value="">Dokument wählen</option>
              {documents.map(d =>
                <option key={d.id} value={d.id}>
                  {d.label}
                </option>
              )}
            </select>
          ) : (
            <input
              type="text"
              value={newLink.documentId}
              onChange={e => setNewLink({ ...newLink, documentId: e.target.value })}
              placeholder="Dokument-ID"
              style={{ minWidth: 120 }}
            />
          )}

          <input
            type="text"
            value={newLink.comment}
            onChange={e => setNewLink({ ...newLink, comment: e.target.value })}
            placeholder="Kommentar"
            style={{ minWidth: 120 }}
          />
          <button onClick={handleAddLink} style={addButtonStyle}>
            Hinzufügen
          </button>
        </div>
      )}

{!isModal && (
      <div style={{ display: "flex", gap: 14, alignItems: "center", margin: "16px 0", flexWrap: "wrap" }}>
  <div style={{ minWidth: 170 }}>
    <Select
      options={instanceOptions}
      value={filterInstance}
      onChange={selected => {
        setFilterInstance(selected);
        setCurrentPage(1);
      }}
      isClearable
      placeholder="Vorgang"
      isDisabled={!!pipelineInstId}
    />
  </div>
  <div style={{ minWidth: 170 }}>
    <Select
      options={DOCUMENT_TYPES}
      value={filterType}
      onChange={selected => {
        setFilterType(selected);
        setCurrentPage(1);
      }}
      isClearable
      placeholder="Dokumenttyp"
    />
  </div>
  <button
    style={{ padding: "5px 12px", background: "#eee", border: "1px solid #bbb", borderRadius: 5 }}
    onClick={() => {
      setFilterInstance(null);
      setFilterType(null);
      setCurrentPage(1);
    }}
  >↩️</button>
</div>
)}
      {/* Tabelle mit Links */}
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Vorgang</th>
            <th>Typ</th>
            <th>Dokument</th>
            <th>Link</th>
            <th>Kommentar</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {links.map(l => (
            <tr key={l.id}>
              <td>{l.id}</td>
              <td>{pipelineInstId
                ? (pipelineInstance ? pipelineInstance.name : '-')
                : (instances.find(i => i.id === l.pipelineInstId)?.name || '-')}
              </td>
              <td>
                {editingLink?.id === l.id ? (
                  <select
                    name="documentType"
                    value={editingLink.documentType}
                    onChange={handleEditInputChange}
                  >
                    <option value="">Typ wählen</option>
                    {DOCUMENT_TYPES.map(dt => <option key={dt.value} value={dt.value}>{dt.label}</option>)}
                  </select>
                ) : (
                  DOCUMENT_TYPES.find(dt => dt.value === l.documentType)?.label || l.documentType
                )}
              </td>
              <td>
                {editingLink?.id === l.id ? (
                  editingLink.documentType && editingLink.documentType !== 'other' ? (
                    <select
                      name="documentId"
                      value={editingLink.documentId}
                      onChange={handleEditInputChange}
                    >
                      <option value="">Dokument wählen</option>
                      {documents.map(d =>
                        <option key={d.id} value={d.id}>
                          {d.label}
                        </option>
                      )}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name="documentId"
                      value={editingLink.documentId}
                      onChange={handleEditInputChange}
                    />
                  )
                ) : (
                  <DocumentNumberCell
                    type={l.documentType}
                    id={l.documentId}
                    allDocumentNumbers={allDocumentNumbers}
                  />
                )}
              </td>
              <td>
                {getFormLink(l.documentType, l.documentId) ? (
                  <button
                    type="button"
                    style={{ background: "none", border: "none", color: "blue", textDecoration: "underline", cursor: "pointer", padding: 0 }}
                    onClick={() => window.open(getFormLink(l.documentType, l.documentId), "_blank")}
                  >
                    Formular
                  </button>
                ) : (
                  "-"
                )}
              </td>
              <td>
                {editingLink?.id === l.id ? (
                  <input
                    type="text"
                    name="comment"
                    value={editingLink.comment || ''}
                    onChange={handleEditInputChange}
                  />
                ) : (l.comment || '-')}
              </td>
              <td>
                {editingLink?.id === l.id ? (
                  <>
                    <button onClick={handleSaveLink} style={saveButtonStyle}>Speichern</button>
                    <button onClick={handleCancelEdit} style={cancelButtonStyle}>Abbrechen</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleEditClick(l)} style={editButtonStyle}>Bearbeiten</button>
                    <button onClick={() => handleDeleteLink(l.id)} style={deleteButtonStyle}>Löschen</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* Pagination */}
      <div style={{ marginTop: '1rem', textAlign: 'center' }}>
  <button
    onClick={() => setCurrentPage(page => Math.max(1, page - 1))}
    disabled={currentPage === 1}
    style={{ fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgb(155, 155, 155)', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
  >
    Vorherige
  </button>
  <span style={{ margin: '0 1rem' }}>
    Seite {currentPage} von {totalPages}
  </span>
  <button
    onClick={() => setCurrentPage(page => Math.min(totalPages, page + 1))}
    disabled={currentPage >= totalPages}
    style={{ fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgb(155, 155, 155)', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
  >
    Nächste
  </button>
      </div>
    </div>
   
  );
};

export default PipelineDocumentLinkForm;
